<template>
  <nav class="breadcrumbs">
    <span v-for="(crumb, index) in breadcrumbs" :key="index">
      <router-link :to="crumb.path">{{ crumb.label }}</router-link>
      <span v-if="index < breadcrumbs.length - 1"> &gt; </span>
    </span>
  </nav>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const breadcrumbs = computed(() =>
  route.matched
    .filter((r) => r.meta?.breadcrumb)
    .map((r) => ({
      label: typeof r.meta.breadcrumb === 'function' ? r.meta.breadcrumb(route) : r.meta.breadcrumb,
      path: r.path,
    })),
)
</script>
